export const SIGNOUT = 'signout';
export const EMAIL_CHANGED = 'email_changed';
export const PASSWORD_CHANGED = 'password_changed';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAIL = 'login_fail';
export const USER_IDENTIFIED = 'user_identified';
export const RESET_PASSWORD_SET = 'reset_password_set';
export const ERROR_PROP_SET = 'error_prop_set';
export const LOADING_TRUE = 'loading_true';
export const AUTH_TYPE = 'auth_type';
export const AUTH_COMPLETE = 'auth_complete';

export const AUTH_USER = 'auth_user';
export const AUTH_ERROR = 'auth_error';

export const GET_USER_PREMIUM_STATUS_COMPLETE = 'get_user_premium_status_complete';
export const GET_STRIPE_DETAILS_COMPLETE = 'get_stripe_details_complete';
export const GET_STRIPE_PLANS_COMPLETE = 'get_stripe_plans_complete';

export const GET_USER_PERSONAL_DETAILS_SUCCESS = 'get_user_personal_details_success';
export const GET_USER_PERSONAL_DETAILS_FAIL = 'get_user_personal_details_fail';
